import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { LIST_FADE_ANIMATION } from '../../../../@prep/shared/list.animation';

import { NotificationService } from './notification.service';

import { PlatformGlobalService } from '../../service/platform-global.service';
import { Subscription } from 'rxjs';

import { MatSnackBar } from '@angular/material/snack-bar';

import { LanguageSelectorModel } from 'src/@prep/shared/language-selector/model/language-selector.model';
import { LanguageSelectorService } from 'src/@prep/shared/language-selector/service/language-selector.service';
import { TopToolbarTextDataEN } from '../toolbar-multi-lang/en-US';
import { TopToolbarTextDataES } from '../toolbar-multi-lang/es-EU';
import { TopToolbarTextDataIT } from '../toolbar-multi-lang/it-IT';
import { HostListener } from '@angular/core';

@Component({
  selector: 'prep-toolbar-notifications',
  templateUrl: './toolbar-notifications.component.html',
  styleUrls: ['./toolbar-notifications.component.scss'],
  animations: [...LIST_FADE_ANIMATION],
  providers: [NotificationService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToolbarNotificationsComponent implements OnInit {
  notifications: any[];
  isOpen: boolean;
  notifyCount = 0;

  // number_of_notifications: number;

  selectedLang: LanguageSelectorModel =
    this.languageSelectorService.getCurrentLanguage();
  LangTextData: any;

  constructor(
    private notificationService: NotificationService,
    private platformGlobalService: PlatformGlobalService,
    private languageSelectorService: LanguageSelectorService,

    private snackbar: MatSnackBar
  ) {
    this.languageSelectorService.language$.subscribe((lang) => {
      this.selectedLang = lang;
      console.log(
        '🌍 Language changed:',
        lang,
        lang.code,
        this.selectedLang.code
      );
      switch (this.selectedLang.code) {
        case 'en': {
          this.LangTextData = TopToolbarTextDataEN;
          console.log('🌍 English Language:', this.LangTextData);
          break;
        }
        case 'es': {
          this.LangTextData = TopToolbarTextDataES;
          console.log('🌍 English Language:', this.LangTextData);
          break;
        }
        case 'it': {
          this.LangTextData = TopToolbarTextDataIT;
          console.log('🌍 English Language:', this.LangTextData);
          break;
        }
        default: {
          this.LangTextData = TopToolbarTextDataEN;
          console.log('🌍 Default Language:', this.LangTextData);
          break;
        }
      }
    });
  }

  @HostListener('document:keydown', ['$event'])
  onKeydown(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      console.log('Escape key pressed');
      this.onClickOutside();
    }
  }

  ngOnInit() {
    this.notifications = [];
    this.notifyCount =
      this.platformGlobalService.myUserInfo.number_of_notifications;
    // Authorize

    // Authorize
    // this.currentUserService.GetCurrentUser().subscribe(
    //   (response) => {
    //     this.platformGlobalService.me = response;
    //     this.platformGlobalService.user.subscribe((me) => {
    //       this.notifyCount = me.number_of_notifications;
    //     });
    //   },
    //   (error) => {
    //     console.log('error', error)
    //   }
    // );

    this.notificationService.getNotifyData().subscribe(
      (res) => {
        console.log('me', res);
        this.notifications = res.result;

        this.notifications.forEach((element) => {
          if (element.read === false) {
            this.notifyCount = this.notifyCount + 1;
          }
        });
      },
      (error) => {
        console.log('error', error);
      }
    );
  }

  markAsRead(notification) {
    notification.read = true;
  }

  dismiss(notification, event) {
    event.stopPropagation();
    if (this.notifyCount > 0) {
      this.notifyCount = this.notifyCount - 1;
    }
    this.notifications.splice(this.notifications.indexOf(notification), 1);

    let formData = {
      id: notification.id,
      read: true,
    };
    this.notificationService.postNotifyStatus(formData).subscribe(
      (res) => {
        this.snackbar.open(
          'Notification marked as read Successfully',
          'OK THANKS',
          {
            duration: 10000,
          }
        );
      },
      (error) => {
        console.log('error', error);
      }
    );
  }

  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }

  onClickOutside() {
    this.isOpen = false;
  }

  markAllAsRead() {
    this.notifications.forEach((notification) => (notification.read = true));
  }
}
